module.exports = __webpack_public_path__ + "media/images/icons/courses-0b66e5fcb3ab76f2ac7d5fbb0c4e31bb.svg";